import styled from 'styled-components';

const CancelButton = styled.span`

`;

export { CancelButton };
